import { Routes } from '@angular/router';

import { LayoutComponent } from '@components';
import {
  ActionsPage,
  BatchUploadPage,
  ContractPage,
  CustomerPage,
  CustomersPage,
  DashboardPage,
  DocumentTypePage,
  DocumentTypesPage,
  ExpensePage,
  ExpensesPage,
  IncidentPage,
  IncidentsPage,
  InspectionImageTypePage,
  InspectionImageTypesPage,
  LoginPage,
  MapPage,
  PaymentPage,
  PaymentsPage,
  ServiceProviderPage,
  ServiceRequestPage,
  ServiceRequestsPage,
  TransactionPage,
  TripPage,
  TripsPage,
  UserPage,
  UsersPage,
  VehiclePage,
  VehiclesPage,
} from '@pages';
import { AuthGuard } from '@services';
import { CriminalRecordCheckPage } from './pages/criminal-record-check/criminal-record-check.page';
import { ServiceProvidersPage } from './pages/service-providers/service-providers.page';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardPage,
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'users',
        component: UsersPage,
        data: { breadcrumb: 'Users' },
      },
      {
        path: 'batch-upload',
        component: BatchUploadPage,
        data: { breadcrumb: 'Batch Upload' },
      },
      {
        path: 'users/:userId',
        component: UserPage,
        data: { breadcrumb: 'User Details' },
      },
      {
        path: 'contract',
        component: ContractPage,
        data: { breadcrumb: 'Contract' },
      },
      {
        path: 'document-types',
        component: DocumentTypesPage,
        data: { breadcrumb: 'Document Types' },
      },
      {
        path: 'document-types/:documentTypeId',
        component: DocumentTypePage,
        data: { breadcrumb: 'Document Type' },
      },
      {
        path: 'actions',
        component: ActionsPage,
        data: { breadcrumb: 'Actions' },
      },
      {
        path: 'payments',
        component: PaymentsPage,
        data: { breadcrumb: 'Payments' },
      },
      {
        path: 'payments/:paymentId',
        component: PaymentPage,
        data: { breadcrumb: 'Payment' },
      },
      {
        path: 'transactions/:transactionId',
        component: TransactionPage,
        data: { breadcrumb: 'Transaction' },
      },
      {
        path: 'vehicles',
        component: VehiclesPage,
        data: { breadcrumb: 'Vehicles' },
      },
      {
        path: 'vehicles/:vehicleId',
        component: VehiclePage,
        data: { breadcrumb: 'Vehicle' },
      },
      {
        path: 'incidents',
        component: IncidentsPage,
        data: { breadcrumb: 'Incidents Page' },
      },
      {
        path: 'incidents/:incidentId',
        component: IncidentPage,
        data: { breadcrumb: 'Incident Details' },
      },
      {
        path: 'map',
        component: MapPage,
        data: { breadcrumb: 'Map Page' },
      },
      {
        path: 'inspection-image-types',
        component: InspectionImageTypesPage,
        data: { breadcrumb: 'Inspection Images' },
      },
      {
        path: 'inspection-image-types/:inspectionImageTypeId',
        component: InspectionImageTypePage,
        data: { breadcrumb: 'Inspection Image' },
      },
      {
        path: 'expenses',
        component: ExpensesPage,
        data: { breadcrumb: 'Expenses' },
      },
      {
        path: 'expenses/:expenseId',
        component: ExpensePage,
        data: { breadcrumb: 'Expense' },
      },
      {
        path: 'service-providers',
        component: ServiceProvidersPage,
        data: { breadcrumb: 'Service Providers' },
      },
      {
        path: 'service-providers/:serviceProviderId',
        component: ServiceProviderPage,
        data: { breadcrumb: 'Service Provider' },
      },
      {
        path: 'customers',
        component: CustomersPage,
        data: { breadcrumb: 'Customers' },
      },
      {
        path: 'customers/:customerId',
        component: CustomerPage,
        data: { breadcrumb: 'Customer' },
      },
      {
        path: 'criminal-checks',
        component: CriminalRecordCheckPage,
        data: { breadcrumb: 'Criminal Background Checks' },
      },
      {
        path: 'service-requests',
        component: ServiceRequestsPage,
        data: { breadcrumb: 'Service Requests' },
      },
      {
        path: 'service-requests/:serviceRequestId',
        component: ServiceRequestPage,
        data: { breadcrumb: 'Service Request' },
      },
      {
        path: 'trips',
        component: TripsPage,
        data: { breadcrumb: 'Trips' },
      },
      {
        path: 'trips/:tripId',
        component: TripPage,
        data: { breadcrumb: 'Trip' },
      },
    ],
  },
  { path: 'auth/login', component: LoginPage },
  { path: '**', redirectTo: '' },
];
